///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching = abcsetup.new_customer_matching || {};
abcsetup.new_customer_matching.events = abcsetup.new_customer_matching.events || {};
abcsetup.new_customer_matching.events.edit = abcsetup.new_customer_matching.events.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching.events.edit = {

    init: function() {
        abcsetup.new_customer_matching.events.common.init();
    },

}
